import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NavbarHTAG } from '../components/NavbarHTAG';
import { FooterHTAG } from '../components/FooterHTAG';

export const LegalNotice = () => {
  return (
    <div className="bg-[#181C25] text-white min-h-screen lg:ml-16">
      <NavbarHTAG />

      {/* Bouton retour */}
      <div className="pt-32 px-4 lg:px-8 relative z-10">
        <div className="container mx-auto mb-8">
          <Link
            to="/"
            className="inline-flex items-center space-x-2 text-blue-400 hover:text-blue-300 transition-colors font-semibold hover:translate-x-1 duration-300"
          >
            <ArrowLeft size={18} />
            <span>Retour à l'accueil</span>
          </Link>
        </div>
      </div>

      {/* Contenu */}
      <section className="py-24 px-4 lg:px-8">
        <div className="container mx-auto max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl font-montserrat font-bold mb-4">
              Mentions <span className="text-blue-500">Légales</span>
            </h1>
            <p className="text-gray-400 mb-12">
              Dernière mise à jour : 8 février 2026
            </p>

            <div className="space-y-12">
              {/* Identité */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  1. Identité de l'éditeur
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p><strong>Entreprise :</strong> HTAG Facility</p>
                  <p><strong>Statut :</strong> SARL</p>
                  <p><strong>Adresse :</strong> Château-Porcien, Ardennes, France</p>
                  <p><strong>Email :</strong> contact@htagfacility.fr</p>
                  <p><strong>Téléphone :</strong> Sur demande via formulaire de contact</p>
                </div>
              </div>

              {/* Hébergement */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  2. Hébergement
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p><strong>Hébergeur :</strong> Vercel Inc.</p>
                  <p><strong>Adresse :</strong> 440 N Barranca Ave, Covina, CA 91723, USA</p>
                  <p><strong>Site :</strong> https://vercel.com</p>
                </div>
              </div>

              {/* Responsabilité */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  3. Responsabilité
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p>
                    HTAG Facility s'efforce de maintenir la précision et la disponibilité du site. Cependant, 
                    nous ne pouvons pas garantir l'absence d'erreurs ou d'interruptions de service.
                  </p>
                  <p>
                    Les informations fournies sont à titre informatif et ne constituent pas un engagement contractuel 
                    sans accord écrit préalable.
                  </p>
                </div>
              </div>

              {/* Propriété intellectuelle */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  4. Propriété Intellectuelle
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p>
                    Tous les éléments du site (textes, images, logos, marques) sont la propriété exclusive 
                    d'HTAG Facility ou utilisés avec autorisation.
                  </p>
                  <p>
                    Toute reproduction, distribution, modification ou transmission sans autorisation écrite 
                    est interdite et pourra être poursuivie légalement.
                  </p>
                </div>
              </div>

              {/* Liens externes */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  5. Liens Externes
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p>
                    Le site peut contenir des liens vers d'autres sites externes. HTAG Facility ne contrôle pas 
                    ces sites et décline toute responsabilité concernant leur contenu, exactitude ou légalité.
                  </p>
                </div>
              </div>

              {/* Modification */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  6. Modification des Mentions
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p>
                    HTAG Facility se réserve le droit de modifier ces mentions légales à tout moment. 
                    Les modifications prennent effet immédiatement. Les utilisateurs sont invités à consulter 
                    régulièrement cette page.
                  </p>
                </div>
              </div>

              {/* Droit applicable */}
              <div>
                <h2 className="text-2xl font-montserrat font-bold text-white mb-4">
                  7. Droit Applicable
                </h2>
                <div className="text-gray-300 space-y-2">
                  <p>
                    Ces mentions légales sont régies par la loi française. Tout litige sera soumis à la compétence 
                    des tribunaux compétents du lieu du siège social.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <FooterHTAG />
    </div>
  );
};

export default LegalNotice;
